require('./base-integration');
const {homeShell} = require('@edreamsodigeo/frontend-shell');
module.exports = homeShell;
